import { Stack } from "expo-router";
import React, { useState } from "react";
import { DrawerToggleButton } from "@react-navigation/drawer";
import colors from '@/constants/Colors';
import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { NewConversationModal } from "../../../components/messages/new-conversation-modal";

export default function MessagesLayout() {
    const [showNewConversationModal, setShowNewConversationModal] = useState(false);

    return (
        <>
            <Stack
                screenOptions={{
                    headerShown: true,
                    headerStyle: {
                        backgroundColor: colors.primary,
                    },
                    headerTintColor: colors.accent,
                    headerBackButtonDisplayMode: 'minimal',
                }}
            >
                <Stack.Screen
                    name="index"
                    options={{
                        headerTitle: "Messages",
                        headerLeft: () => <DrawerToggleButton tintColor={colors.accent} />,
                        headerRight: () => (
                            <Pressable
                                onPress={() => setShowNewConversationModal(true)}
                                className="px-4 py-2"
                            >
                                <Ionicons name="add" size={24} color={colors.accent} />
                            </Pressable>
                        ),
                    }}
                />
                {/* Hide the header at this level and let the nested layout handle it */}
                <Stack.Screen
                    name="[id]"
                    options={{
                        headerShown: false, // Hide header at this level
                    }}
                    getId={({ params }) => `conversation-${params?.id}`}
                />
            </Stack>

            {/* New Conversation Modal */}
            <NewConversationModal
                visible={showNewConversationModal}
                onClose={() => setShowNewConversationModal(false)}
            />
        </>
    );
} 